import type { OrgRole } from "@io-spoke/contracts/orgs";
import type { RouteName } from "./router";

export type OrgRoleView = "agent" | "manager" | "executive";

const routeAccessByRoleView: Record<OrgRoleView, RouteName[]> = {
  agent: [
    "rescues",
    "obligations",
    "aiEvaluation",
    "dashboard",
    "security",
    "inbox",
    "review",
    "leads",
    "entity",
    "thread",
    "customer",
    "lens",
    "settings",
    "team",
    "orgInvite",
    "integrations",
    "orgSetup",
  ],
  manager: [
    "rescues",
    "obligations",
    "aiEvaluation",
    "dashboard",
    "security",
    "inbox",
    "review",
    "leads",
    "entity",
    "thread",
    "customer",
    "triageRules",
    "slaRules",
    "lens",
    "settings",
    "team",
    "orgInvite",
    "integrations",
    "orgSetup",
  ],
  executive: [
    "rescues",
    "obligations",
    "aiEvaluation",
    "dashboard",
    "security",
    "inbox",
    "review",
    "leads",
    "entity",
    "thread",
    "customer",
    "triageRules",
    "slaRules",
    "lens",
    "settings",
    "team",
    "orgInvite",
    "integrations",
    "billing",
    "orgSetup",
  ],
};

const defaultRouteByRoleView: Record<OrgRoleView, string> = {
  agent: "/inbox",
  manager: "/rescues",
  executive: "/rescues",
};

const roleViewLabelByRoleView: Record<OrgRoleView, string> = {
  agent: "Agent",
  manager: "Manager",
  executive: "Executive",
};

export function getRoleViewFromOrgRole(role?: OrgRole | null): OrgRoleView {
  if (role === "owner") {
    return "executive";
  }
  if (role === "admin") {
    return "manager";
  }
  return "agent";
}

export function getDefaultRouteForRoleView(roleView: OrgRoleView): string {
  return defaultRouteByRoleView[roleView];
}

export function getRoleViewLabel(roleView: OrgRoleView): string {
  return roleViewLabelByRoleView[roleView];
}

export function canAccessRouteForRoleView(
  roleView: OrgRoleView,
  route: RouteName
): boolean {
  return routeAccessByRoleView[roleView].includes(route);
}
